




























import { listFactory } from '@/main/pages';
import { deleteButton, printButton } from '@/main/utils/tableOperations';

import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { store } from './store/list';
import { NAME, ULOZENI_TYP, reportUrl } from './constants';
import { apiProvider } from './api';

export default listFactory(NAME, store).extend({
	components: {
		DmsPdfDialog,
	},
	data() {
		return {
			reportUrl,
			dialogVisible: false,
			dialogFilter: {} as Record<string, any>,
			ULOZENI_TYP,
			textMessage: this.LocalizePopisostatni('UzavRozpracHlas1'),
		};
	},
	computed: {
		extraButtons(): any {
			return {
				...deleteButton((e: any, cells: any) => this.deleteItem(cells[this.table!.cellNames!.idColumn])),
				...printButton((e: any, cells: any) => this.openReport(cells)),
			};
		},
		uzaverkaFilter(): Record<string, any> {
			return {
				ProvozovnaId: this.ProvozovnaId,
				UzavSporoPrp: this.ulozeniTyp,
			};
		},
		provozovna(): any {
			return this.dropdownList.ProvozovnaId ? this.dropdownList.ProvozovnaId.find((item: any) => item.Value === this.ProvozovnaId) : undefined;
		},
	},
	methods: {
		openReport(data: any) {
			this.dialogFilter = {
				GroupMode: this.TiskTrideni, // musi chodit ze selectu
				UzaverkaId: data[0],
			};
			this.dialogVisible = true;
		},
		async uzaverka() {
			this.startLoading();
			const { data } = await apiProvider.uzaverkaRozpracovanosti(this.uzaverkaFilter);
			if (data) {
				this.textMessage = `${this.LocalizePopisostatni('UzavRozpracHlas1')} ${this.provozovna.Text} ${this.LocalizePopisostatni('UzavRozpracHlas4')}`;
			}
			if (this.doPrint) {
				this.dialogFilter = {
					GroupMode: this.TiskTrideni,
					UzaverkaId: data.id,
				};
				this.dialogVisible = true;
			}
			this.refreshFun();
			this.endLoading();
		},
	},
});
